const utilities = () => {
    document.addEventListener("DOMContentLoaded", function() {
        smoothScroll();
    });
}

utilities();

const smoothScroll = () => {
    var links = document.querySelectorAll('a[href*="#"]:not([href="#"])');

    links.forEach(function(link) {
        link.addEventListener("click", function(event) {
            if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
                var targetId = this.hash.slice(1);
                var target = document.getElementById(targetId) || document.getElementsByName(targetId)[0];

                if (target) {
                    event.preventDefault();
                    var topOffset = window.scrollY + target.getBoundingClientRect().top - 15;
                    window.scroll({
                        top: topOffset,
                        behavior: 'smooth'
                    });
                }
            }
        });
    });
}